import styled from 'styled-components';

const ButtonBox = styled.div`
  width: 100%;
  flex-direction: inline-block;
  align-items: center;
  min-height: 70px;
  color: #ccc;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 400px;
`;

export default ButtonBox;
